module.exports = __webpack_public_path__ + "img/lacoste_content_img_06.b5b1a20c.jpg";